export const COMPARTMENT_DOORS_GALLERY_LIST_PRESET = [
  {
    displayedName: 'Зеркальные двери-купе',
    addText: 'в чёрном профиле',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    style: 'compartment-doors',
    rating: 1000,
  },
  {
    displayedName: 'Двери-купе',
    addText: 'в древесных тонах',
    mediaMainPhoto: ['2.jpg/2.jpg'],
    style: 'compartment-doors',
    rating: 1016,
  },
  {
    displayedName: 'Матовый шкаф-купе',
    addText: 'со стеклянными фасадами ',
    mediaMainPhoto: ['3.jpg/3.jpg'],
    style: 'compartment-doors',
    rating: 1005,
  },
  {
    displayedName: 'Белые матовые двери-купе',
    addText: 'с декоративными вставками',
    mediaMainPhoto: ['4.jpg/4.jpg'],
    style: 'compartment-doors',
    rating: 1011,
  },
  {
    displayedName: 'Зеркальные двери-купе',
    addText: 'с чёрным узким профилем',
    mediaMainPhoto: ['5.jpg/5.jpg'],
    style: 'compartment-doors',
    rating: 1008,
  },
  {
    displayedName: 'Стеклянные двери-купе',
    addText: 'с черным профилем',
    mediaMainPhoto: ['6.jpg/06.jpg'],
    style: 'compartment-doors',
    rating: 1028,
  },
  {
    displayedName: 'Стеклянные двери-купе',
    addText: 'с золотым профилем',
    mediaMainPhoto: ['7.jpg/07.jpg'],
    style: 'compartment-doors',
    rating: 1029,
  },
  {
    displayedName: 'Нюдовые двери-купе',
    addText: 'со стеклянными вставкам',
    mediaMainPhoto: ['8.jpg/08.jpg'],
    style: 'compartment-doors',
    rating: 1043,
  },
  {
    displayedName: 'Матовые двери-купе',
    addText: 'в темно-сером цвете',
    mediaMainPhoto: ['9.jpg/9.jpg'],
    style: 'compartment-doors',
    rating: 1038,
  },
  {
    displayedName: 'Стклянные двери-купе',
    addText: 'Чёрные ',
    mediaMainPhoto: ['10.jpg/10.jpg'],
    style: 'compartment-doors',
    rating: 1070,
  },
  {
    displayedName: 'Зеркальные двери-купе',
    addText: 'с декоративными вставками',
    mediaMainPhoto: ['11.jpg/11.jpg'],
    style: 'compartment-doors',
    rating: 1071,
  },
  {
    displayedName: 'Глянцевые двери-купе',
    addText: 'в бежевом цвете',
    mediaMainPhoto: ['12.jpg/12.jpg'],
    style: 'compartment-doors',
    rating: 1021,
  },
  {
    displayedName: 'Зеркальные двери-купе',
    addText: 'с черным профилем',
    mediaMainPhoto: ['13.jpg/13.jpg'],
    style: 'compartment-doors',
    rating: 1054,
  },
  {
    displayedName: 'Зеркальные двери-купе',
    addText: 'с вставками',
    mediaMainPhoto: ['14.jpg/14.jpg'],
    style: 'compartment-doors',
    rating: 1081,
  },
  {
    displayedName: 'Двери-купе ',
    addText: 'в стиле «Лофт»',
    mediaMainPhoto: ['15.jpg/15.jpg'],
    style: 'compartment-doors',
    rating: 1047,
  },
  {
    displayedName: 'Двери-купе',
    addText: 'в оттенке «Дуб Бардолино»',
    mediaMainPhoto: ['16.jpg/16.jpg'],
    style: 'compartment-doors',
    rating: 1055,
  },
];
